import { EWeekdays } from '@timeedit/types/lib/enums';

const convertTimeToMinutes = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins
    .toString()
    .padStart(2, '0')}`;
};

export const timeslotColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Start Time',
    dataIndex: 'startTime',
    key: 'startTime',
    render: (startTime: number) => convertTimeToMinutes(startTime),
  },
  {
    title: 'End Time',
    dataIndex: 'endTime',
    key: 'endTime',
    render: (endTime: number) => convertTimeToMinutes(endTime),
  },
  {
    title: 'Week day',
    dataIndex: 'weekdays',
    key: 'weekdays',
    render: (weekdays: number[]) => {
      return weekdays.map((day) => Object.keys(EWeekdays)?.[day]).join(', ');
    },
  },
];
